import React, { useEffect, useState } from 'react'
import { OrgPicker } from '../org-search/org-picker'
import { organizationNameOf } from '../org-search/org-search-api'
import { Label } from './common/label'
import { useForm } from './form'

// A form's organization (course copy, course from template, template copy:
// a system admin picks the destination). The searchable picker asks content
// for a page at a time (shared/org-search), never the whole list. onChange
// gets { id, name }, or null when cleared.
export const FormSimpleOrgaizationSelect = ({ name, label, defaultValue, hidden, required, onChange }) => {
  const { register, setValue, getFormDisabled } = useForm(name, { required, valueAsNumber: true, forceChange: true, shouldDirty: true })

  const [selected, updateSelected] = useState(defaultValue ? String(defaultValue) : '')

  useEffect(() => updateSelected(defaultValue ? String(defaultValue) : ''), [defaultValue])

  useEffect(
    () => {
      setValue(selected ? Number(selected) : null)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selected]
  )

  const handleChange = value => {
    updateSelected(value)
    onChange && onChange(value ? { id: Number(value), name: organizationNameOf(value) } : null)
  }

  return (
    <Label name={name} label={label} hidden={hidden} required={required}>
      <input type="hidden" {...register()} />
      <OrgPicker id={`${name}-picker`} label="Organization" value={selected} onChange={handleChange} disabled={getFormDisabled()} required={required} />
    </Label>
  )
}
